import { assertNever } from 'owa-assert';
import type { ProjectId } from 'owa-timestream-types';
import getStore from '../store';
import logProjectNotFound from '../utils/logProjectNotFound';

export default function getProject(projectId: ProjectId) {
    const project = getStore().projects.get(projectId);

    if (!project) {
        logProjectNotFound(projectId);
        return assertNever(`unknown project ${projectId}` as never);
    }
    return project;
}
